/* eslint-disable import/no-extraneous-dependencies */
// import sum from 'lodash/sum';
// import uniq from 'lodash/uniq';
// import uniqBy from 'lodash/uniqBy';
import { createSlice } from '@reduxjs/toolkit';
// utils
import { axiosInstance } from "../../utils/axiosInstance"

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  error: null,
  saveHotels: [],
  hotelCityList: [],
  hotelList: [],
  hotelDetail: [],
  hotelBookingResponse: [],
};

const slice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    //GET SAVEHOTELS
    getSaveHotelSuccess(state, action) {
      state.isLoading = false;
      state.saveBookingHotels = action.payload;
    },
    //GET getHotelCityList
    getHolidayListSuccess(state, action) {
      state.isLoading = false;
      state.holidayListRes = action.payload;
    },
    getHolidayDetailListSuccess(state, action) {
      state.isLoading = false;
      state.holidayDetailListRes = action.payload;
    },
    getHolidaySaveBookingSuccess(state, action) {
      state.isLoading = false;
      state.holidaySaveRec = action.payload;
    },
    getSearchHolidaySuccess(state, action) {
      state.isLoading = false;
      state.holidaySearchRes = action.payload;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const {
  getCart,
  addToCart,
  resetCart,
  gotoStep,
  backStep,
  nextStep,
  deleteCart,
  createBilling,
  applyShipping,
  applyDiscount,
  increaseQuantity,
  decreaseQuantity,
} = slice.actions;

// ----------------------------------------------------------------------

//SAVEHOTELSBOOKINGS

export function holidayList(hotelBooking) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/tour/list`,
        hotelBooking,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(
        slice.actions.getHolidayListSuccess(response.data.holidayPackages)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function holidayDetailList(hotelBooking) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/holiday/detail`,
        hotelBooking,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(
        slice.actions.getHolidayDetailListSuccess(response.data.holidayPackage)
      );
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function holidaySaveBooking(hotelBooking) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/booking/holidayPackage`,
        hotelBooking,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch(slice.actions.getHolidaySaveBookingSuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function searchHoliday(obj) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());

    try {
      const response = await axiosInstance.post(
        `${process.env.BACKEND_URL}/tour/searchHoliday`,
        obj
      );
      dispatch(slice.actions.getSearchHolidaySuccess(response.data));
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error));
    }
  };
}
